import { ZOOM_LEVEL } from "Common/dictionaries/zoomLevel";
import { themeVariables } from "Components/theme";
import { FreeEdgeLabelModel, InteriorStretchLabelModel, StringTemplateNodeStyle, Theme, VoidPortStyle } from "yfiles";
import { NODE_GROUP_MAX_SIZE, NODE_GROUP_MIN_SIZE, NODE_MAX_SIZE, NODE_MIN_SIZE } from "../../constants";
import nodeType from "../nodeType";
import CustomEdgeStyle from "./customEdgeStyle";
import HtmlLabelStyle from "./htmlLabelStyle";
import initializeConverters from "./initializeConverters";
import LevelOfDetailNodeStyle from "./levelOfDetailNodeStyle";
import { font, fontSizeMap, groupNodeCountMarkDef, groupNodeHeaderText, groupNodeRect, nodeAdditionalImage, nodeImage, paddingMap, regularNodeRect } from "./svgRenders";
export default (graphComponent, regularNodeRenderCallback, groupRenderCallback) => {
    if (!(graphComponent === null || graphComponent === void 0 ? void 0 : graphComponent.graph))
        return;
    initializeConverters();
    graphComponent.graph.nodeDefaults.style = new LevelOfDetailNodeStyle(graphComponent, nodeType.REGULAR, new StringTemplateNodeStyle(`<g>
      ${regularNodeRect(true, ZOOM_LEVEL.HIGH)}
      ${nodeImage}
      ${nodeAdditionalImage}
    </g>`), new StringTemplateNodeStyle(`<g>
      ${regularNodeRect(true, ZOOM_LEVEL.MEDIUM)}
      ${nodeImage}
    </g>`), new StringTemplateNodeStyle(`<g>
      ${regularNodeRect(false, ZOOM_LEVEL.LOW)}
    </g>`));
    graphComponent.graph.nodeDefaults.shareStyleInstance = false;
    graphComponent.graph.nodeDefaults.labels.layoutParameter = InteriorStretchLabelModel.CENTER;
    graphComponent.graph.nodeDefaults.labels.style = new HtmlLabelStyle(nodeType.REGULAR, NODE_MIN_SIZE, NODE_MAX_SIZE, font, fontSizeMap[nodeType.REGULAR], paddingMap[nodeType.REGULAR], regularNodeRenderCallback);
    graphComponent.graph.groupNodeDefaults.style = new LevelOfDetailNodeStyle(graphComponent, nodeType.GROUP, new StringTemplateNodeStyle(`<g>
      ${groupNodeCountMarkDef}
      ${groupNodeRect(ZOOM_LEVEL.HIGH)}
      ${groupNodeHeaderText(ZOOM_LEVEL.HIGH)}
    </g>`), new StringTemplateNodeStyle(`<g>
      ${groupNodeCountMarkDef}
      ${groupNodeRect(ZOOM_LEVEL.MEDIUM)}
      ${groupNodeHeaderText(ZOOM_LEVEL.MEDIUM)}
    </g>`), new StringTemplateNodeStyle(`<g>
      ${groupNodeCountMarkDef}
      ${groupNodeRect(ZOOM_LEVEL.LOW)}
      ${groupNodeHeaderText(ZOOM_LEVEL.LOW)}
    </g>`));
    graphComponent.graph.groupNodeDefaults.shareStyleInstance = true;
    graphComponent.graph.groupNodeDefaults.labels.layoutParameter = InteriorStretchLabelModel.CENTER;
    graphComponent.graph.groupNodeDefaults.labels.style = new HtmlLabelStyle(nodeType.GROUP, NODE_GROUP_MIN_SIZE, NODE_GROUP_MAX_SIZE, font, fontSizeMap[nodeType.GROUP], paddingMap[nodeType.GROUP], groupRenderCallback);
    graphComponent.graph.edgeDefaults.labels.layoutParameter =
        FreeEdgeLabelModel.INSTANCE.createDefaultParameter();
    graphComponent.graph.edgeDefaults.style = new CustomEdgeStyle();
    graphComponent.graph.edgeDefaults.shareStyleInstance = false;
    const theme = new Theme({
        variant: "simple-round",
        primaryColor: themeVariables["brand-primary-500"],
        backgroundColor: "#FFF"
    });
    graphComponent.theme = theme;
    graphComponent.graph.edgeDefaults.ports.style = VoidPortStyle.INSTANCE;
    graphComponent.graph.nodeDefaults.ports.style = VoidPortStyle.INSTANCE;
    graphComponent.graph.decorator.nodeDecorator.reshapeHandlerDecorator.hideImplementation();
};
